"use strict";
// tslint:disable:max-classes-per-file
// tslint:disable:triple-equals
// tslint:disable:only-arrow-functions
/*!
// <copyright file="html-binding-telemetry.ts" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/
var $dyn;
(function ($dyn) {
    var util;
    (function (util) {
        /**
         * Generate a RFC4122 version 4 compliant pseudo-random GUID
         */
        function newGuid() {
            // Generate an integer in the range [0, upper)
            function randomInteger(upper) {
                return Math.floor(Math.random() * upper);
            }
            function randomHexDigit() {
                return "0123456789abcdef".charAt(randomInteger(16));
            }
            // Make the GUID RFC4122 compliant by setting the most significant half-byte of the 7th byte (version number) to 4,
            // since the 2 most significant bits of the 9th byte are fixed, only 8, 9, A or B are possible in that half-byte
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/x/g, randomHexDigit).replace("y", "89ab".charAt(randomInteger(4)));
        }
        util.newGuid = newGuid;
    })(util = $dyn.util || ($dyn.util = {}));
    // Brower session and browser interaction activity Ids
    var Activity = /** @class */ (function () {
        function Activity(id) {
            this.msTenMinutes = 600000;
            if ($dyn.flags.staticGenerators) {
                this.Id = "11111111-1111-1111-1111-111111111111";
                this.Timestamp = Date.UTC(0, 0, 0, 0, 0, 0);
            }
            else {
                this.Id = id !== undefined && id !== null ? id : "00000000-0000-0000-0000-000000000000";
                this.Timestamp = Date.now();
            }
        }
        Object.defineProperty(Activity.prototype, "UtcTimestamp", {
            get: function () {
                return new Date(this.Timestamp).toISOString();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Activity.prototype, "SearchStartTimestamp", {
            get: function () {
                return new Date(this.Timestamp - this.msTenMinutes);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Activity.prototype, "SearchEndTimestamp", {
            get: function () {
                return new Date(this.Timestamp + this.msTenMinutes);
            },
            enumerable: false,
            configurable: true
        });
        return Activity;
    }());
    var BrowserActivity = /** @class */ (function () {
        function BrowserActivity() {
            this.setBrowserSessionActivityIDMark = "SetBrowserSessionActivty ID:{0}, Timestamp {1}";
            this.pattern = /(.*)\..*(Z.*)\..*(Z.*)/;
            this.feedbackText = ";[Browser[Session[Activity[ID:{0},Timestamp:{1}]],[Interaction[Activity[ID:{2},Timestamp:{3}]]";
            this.usePreviousActivityKey = false;
            this.BrowserSessionActivity = new Activity($dyn.util.newGuid());
            this.BrowserInteractionActivity = new Activity();
            this.TraceLogNodeName = "";
            this.TraceLogNamespace = "";
            this.TraceLogTenant = "";
            this.TraceLogRole = "";
            this.searchTraceLogUrlTemplate = 
            // tslint:disable-next-line:max-line-length
            "https://test1.diagnostics.monitoring.core.windows.net/content/madashboard/madashboard.html?instance={0}%2f{1}%2f{2}%2f{3}%2f&tabpage=localsearch&table=TraceLog&start={4}&end={5}&query=%22browserSessionActivityId%3d%3d%22%22{6}%22%22%22%3bselect+ActivityId";
            this.searchTraceLogUrl = "";
            this.aosRoleInstance = "";
            this.aosId = "";
            $dyn.performanceMark($dyn.format(this.setBrowserSessionActivityIDMark, this.BrowserSessionActivity.Id, this.BrowserSessionActivity.Timestamp));
        }
        BrowserActivity.prototype.formatTraceLogUrl = function (startTimestamp, endTimestamp) {
            var url = "";
            if (this.TraceLogNodeName && this.TraceLogNodeName.length > 0) {
                var temp = $dyn.format(this.searchTraceLogUrlTemplate, this.TraceLogNamespace, this.TraceLogTenant, this.TraceLogRole, this.TraceLogNodeName, startTimestamp
                    .toISOString()
                    .replace("T", "+")
                    .replace(/:/g, "%3a"), endTimestamp
                    .toISOString()
                    .replace("T", "+")
                    .replace(/:/g, "%3a"), this.BrowserSessionActivity.Id);
                var matches = temp.match(this.pattern);
                url = matches[1] + matches[2] + matches[3];
            }
            return url;
        };
        Object.defineProperty(BrowserActivity.prototype, "SearchTraceLog", {
            get: function () {
                return $dyn.flags.searchTraceLog;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BrowserActivity.prototype, "AOSRoleInstance", {
            get: function () {
                return this.TraceLogNodeName;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BrowserActivity.prototype, "SearchTraceLogUrl", {
            get: function () {
                return this.formatTraceLogUrl(this.BrowserInteractionActivity.SearchStartTimestamp, this.BrowserInteractionActivity.SearchEndTimestamp);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BrowserActivity.prototype, "FeedbackText", {
            get: function () {
                return $dyn.format(this.feedbackText, this.BrowserSessionActivity.Id, new Date(this.BrowserSessionActivity.Timestamp).toISOString(), this.BrowserInteractionActivity.Id, new Date(this.BrowserInteractionActivity.Timestamp).toISOString());
            },
            enumerable: false,
            configurable: true
        });
        BrowserActivity.prototype.newInteraction = function (actvityId) {
            this.BrowserInteractionActivity.Id = actvityId;
            this.BrowserInteractionActivity.Timestamp = Date.now();
        };
        BrowserActivity.prototype.getPreviousActivityId = function () {
            return this.BrowserInteractionActivity.Id;
        };
        // Create a new browser session ID, reset its timestamps and the interaction activity ID
        // Values for the IDs and the expiration can be optionally passed in
        BrowserActivity.prototype.resetBrowserSessionActivity = function (timestamp, data) {
            this.BrowserSessionActivity.Id = data ? data.bid : $dyn.util.newGuid();
            this.BrowserSessionActivity.Timestamp = timestamp;
            if (data.aid) {
                this.newInteraction(data.aid);
            }
            $dyn.performanceMark($dyn.format(this.setBrowserSessionActivityIDMark, this.BrowserSessionActivity.Id, this.BrowserSessionActivity.Timestamp));
        };
        return BrowserActivity;
    }());
    $dyn.browserActivity = new BrowserActivity();
    /**
     * @internal
     */
    var telemetry;
    (function (telemetry) {
        // To consume our telemetry, enable this flag and use the _eventQueue
        if ($dyn.telemetry.enabled) {
            // Hook into the control creation process by wrapping the init method, a hook point on the Control role.
            var initControl_1 = $dyn.roleHandlers.Control.prototype.initControl;
            $dyn.roleHandlers.Control.prototype.initControl = function (control) {
                // Case the base method
                initControl_1.apply(this, arguments);
                if (control) {
                    var typeName = control.TypeName;
                    if (typeName) {
                        var typeHandler = $dyn.telemetry.typeHandlers[typeName];
                        if (typeHandler) {
                            typeHandler.instrument(control);
                        }
                    }
                    // Put additional handlers for other visitors that instrument the control.
                }
            };
        }
        var _batchId = 1;
        /**
         * The array containing the unsent telemetry events
         * @internal
         */
        telemetry._eventQueue = [];
        /**
         * @private
         */
        telemetry._areEventsStored = false;
        /**
         * @private
         */
        telemetry._storageKey = "$dyn.telemetry.persistentEventQueue";
        /**
         * Add an event to the event queue
         * @internal
         * @param evt The telemetry event
         */
        function addEvent(evt) {
            if ($dyn.telemetry.enabled) {
                evt.EventGroupId = _batchId;
                evt.EventTimestamp = Date.now();
                if ($dyn.telemetry.addEventInternal) {
                    $dyn.telemetry.addEventInternal(evt);
                }
                else {
                    $dyn.telemetry._eventQueue.push(evt);
                }
            }
        }
        telemetry.addEvent = addEvent;
        /**
         * Add an event to the event queue that will persist in local storage until sent.
         * @internal
         * @param evt The telemetry event
         */
        function addPersistentEvent(evt) {
            if ($dyn.telemetry.enabled) {
                $dyn.telemetry.addEvent(evt);
                if ($dyn.util.localStorageSupported()) {
                    var persistentEventString = window.localStorage.getItem($dyn.telemetry._storageKey);
                    var persistentEventQueue = [];
                    if (persistentEventString) {
                        persistentEventQueue = JSON.parse(persistentEventString);
                    }
                    persistentEventQueue.push(evt);
                    try {
                        $dyn.telemetry._areEventsStored = true;
                        window.localStorage.setItem($dyn.telemetry._storageKey, JSON.stringify(persistentEventQueue));
                    }
                    catch (e) {
                        $dyn.util.localStorageErorrHandler(e.name);
                    }
                }
            }
        }
        telemetry.addPersistentEvent = addPersistentEvent;
        /**
         * Clear the event queue
         * @internal
         */
        function clearEvents() {
            _batchId++;
            $dyn.telemetry._eventQueue.length = 0;
        }
        telemetry.clearEvents = clearEvents;
        /**
         * Add an event to the event queue that will persist in local storage until sent.
         * @internal
         * @param evt The telemetry event
         */
        function clearPersistentEventStorage(evt) {
            if ($dyn.telemetry._areEventsStored) {
                window.localStorage.removeItem($dyn.telemetry._storageKey);
                $dyn.telemetry._areEventsStored = false;
            }
        }
        telemetry.clearPersistentEventStorage = clearPersistentEventStorage;
        // TODO: Consider flattening the event hierarchy or not using WCF for telemetry
        /**
         * The names of the WCF event types
         */
        var TelemetryEventDataType;
        (function (TelemetryEventDataType) {
            TelemetryEventDataType["errorDisplayed"] = "ErrorDisplayedEventData";
            TelemetryEventDataType["performance"] = "PerformanceEventData";
            TelemetryEventDataType["action"] = "ActionEventData";
            TelemetryEventDataType["sessionAction"] = "SessionActionEventData";
            TelemetryEventDataType["userFeedback"] = "UserFeedbackEventData";
            TelemetryEventDataType["ping"] = "PingEventData";
            TelemetryEventDataType["navigationSearch"] = "NavigationSearchEventData";
            TelemetryEventDataType["navigation"] = "NavigationEventData";
            TelemetryEventDataType["actionSearch"] = "ActionSearchEventData";
            TelemetryEventDataType["communication"] = "CommunicationEventData";
        })(TelemetryEventDataType = telemetry.TelemetryEventDataType || (telemetry.TelemetryEventDataType = {}));
        /**
         * Create an object with the $type property $dyn.telemetry.TelemetryEventDataType.performance
         * @internal
         */
        function createPerformanceEvent() {
            return {
                $type: $dyn.telemetry.TelemetryEventDataType.performance,
            };
        }
        telemetry.createPerformanceEvent = createPerformanceEvent;
        /**
         * Create an object with the $type property $dyn.telemetry.TelemetryEventDataType.errorDisplayed
         * @internal
         */
        function createErrorEvent() {
            return {
                $type: $dyn.telemetry.TelemetryEventDataType.errorDisplayed,
            };
        }
        telemetry.createErrorEvent = createErrorEvent;
        /**
         * Create an object with the $type property $dyn.telemetry.TelemetryEventDataType.action
         * @internal
         */
        function createActionEvent() {
            return {
                $type: $dyn.telemetry.TelemetryEventDataType.action,
            };
        }
        telemetry.createActionEvent = createActionEvent;
        /**
         * Create an object with the $type property $dyn.telemetry.TelemetryEventDataType.sessionAction
         * @internal
         */
        function createSessionEvent() {
            return {
                $type: $dyn.telemetry.TelemetryEventDataType.sessionAction,
            };
        }
        telemetry.createSessionEvent = createSessionEvent;
        /**
         * Create an object with the $type property $dyn.telemetry.TelemetryEventDataType.userFeedback
         * @internal
         */
        function createFeedbackEvent() {
            return {
                $type: $dyn.telemetry.TelemetryEventDataType.userFeedback,
            };
        }
        telemetry.createFeedbackEvent = createFeedbackEvent;
        /**
         * Create an object with the $type property $dyn.telemetry.TelemetryEventDataType.ping
         * @internal
         */
        function createPingEvent() {
            return {
                $type: $dyn.telemetry.TelemetryEventDataType.ping,
            };
        }
        telemetry.createPingEvent = createPingEvent;
        /**
         * Create an object with the $type property $dyn.telemetry.TelemetryEventDataType.navigationSearch
         * @internal
         */
        function createNavigationSearchEvent() {
            return {
                $type: $dyn.telemetry.TelemetryEventDataType.navigationSearch,
            };
        }
        telemetry.createNavigationSearchEvent = createNavigationSearchEvent;
        /**
         * Create an object with the $type property $dyn.telemetry.TelemetryEventDataType.navigation
         * @internal
         */
        function createNavigationEvent() {
            return {
                $type: $dyn.telemetry.TelemetryEventDataType.navigation,
            };
        }
        telemetry.createNavigationEvent = createNavigationEvent;
        /**
         * Create an object with the $type property $dyn.telemetry.TelemetryEventDataType.actionSearch
         * @internal
         */
        function createActionSearchEvent() {
            return {
                $type: $dyn.telemetry.TelemetryEventDataType.actionSearch,
            };
        }
        telemetry.createActionSearchEvent = createActionSearchEvent;
        /**
         * Create an object with the $type property $dyn.telemetry.TelemetryEventDataType.communication
         * @internal
         */
        function createCommunicationEvent() {
            return {
                $type: $dyn.telemetry.TelemetryEventDataType.communication,
            };
        }
        telemetry.createCommunicationEvent = createCommunicationEvent;
        /**
         * The different type of Performance events
         * @internal
         */
        var PerformanceEvents;
        (function (PerformanceEvents) {
            PerformanceEvents[PerformanceEvents["openStart"] = 0] = "openStart";
            PerformanceEvents[PerformanceEvents["openStop"] = 1] = "openStop";
            PerformanceEvents[PerformanceEvents["renderStart"] = 2] = "renderStart";
            PerformanceEvents[PerformanceEvents["renderStop"] = 3] = "renderStop";
            PerformanceEvents[PerformanceEvents["preClient"] = 4] = "preClient";
            PerformanceEvents[PerformanceEvents["server"] = 5] = "server";
            PerformanceEvents[PerformanceEvents["postClient"] = 6] = "postClient";
            PerformanceEvents[PerformanceEvents["blockingDiv"] = 7] = "blockingDiv";
        })(PerformanceEvents = telemetry.PerformanceEvents || (telemetry.PerformanceEvents = {}));
        /**
         * The different type of Action events
         * @internal
         */
        var ActionEvents;
        (function (ActionEvents) {
            ActionEvents[ActionEvents["receivedFocus"] = 0] = "receivedFocus";
            ActionEvents[ActionEvents["valueChanged"] = 1] = "valueChanged";
            ActionEvents[ActionEvents["buttonClicked"] = 2] = "buttonClicked";
            ActionEvents[ActionEvents["copyOccurred"] = 3] = "copyOccurred";
            ActionEvents[ActionEvents["cutOccurred"] = 4] = "cutOccurred";
            ActionEvents[ActionEvents["pasteOccurred"] = 5] = "pasteOccurred";
            ActionEvents[ActionEvents["lookupActivated"] = 6] = "lookupActivated";
            ActionEvents[ActionEvents["jumpRefExecuted"] = 7] = "jumpRefExecuted";
            ActionEvents[ActionEvents["itemSelected"] = 8] = "itemSelected";
            ActionEvents[ActionEvents["itemUnselected"] = 9] = "itemUnselected";
            ActionEvents[ActionEvents["selectAll"] = 10] = "selectAll";
            ActionEvents[ActionEvents["unselectAll"] = 11] = "unselectAll";
            ActionEvents[ActionEvents["addItem"] = 12] = "addItem";
            ActionEvents[ActionEvents["removeItem"] = 13] = "removeItem";
            ActionEvents[ActionEvents["containerExpand"] = 14] = "containerExpand";
            ActionEvents[ActionEvents["containerCollapse"] = 15] = "containerCollapse";
            ActionEvents[ActionEvents["custom"] = 16] = "custom";
            ActionEvents[ActionEvents["hotKeyUsed"] = 17] = "hotKeyUsed";
            ActionEvents[ActionEvents["backNavigation"] = 18] = "backNavigation";
            ActionEvents[ActionEvents["previewDisplayed"] = 19] = "previewDisplayed";
            ActionEvents[ActionEvents["gridColumnSort"] = 20] = "gridColumnSort";
            ActionEvents[ActionEvents["gridColumnFilter"] = 21] = "gridColumnFilter";
            ActionEvents[ActionEvents["quickFilter"] = 22] = "quickFilter";
            ActionEvents[ActionEvents["filterDisplayFilter"] = 23] = "filterDisplayFilter";
            ActionEvents[ActionEvents["filterDisplayAddField"] = 24] = "filterDisplayAddField";
            ActionEvents[ActionEvents["filterDisplayReset"] = 25] = "filterDisplayReset";
            ActionEvents[ActionEvents["formPopout"] = 26] = "formPopout";
            ActionEvents[ActionEvents["keystrokeLoss"] = 27] = "keystrokeLoss";
            ActionEvents[ActionEvents["gridRequestTotals"] = 28] = "gridRequestTotals";
            ActionEvents[ActionEvents["gridPasteFromExcel"] = 29] = "gridPasteFromExcel";
        })(ActionEvents = telemetry.ActionEvents || (telemetry.ActionEvents = {}));
        /**
         * @internal
         */
        var FeedbackType;
        (function (FeedbackType) {
            FeedbackType[FeedbackType["notSpecified"] = 0] = "notSpecified";
            FeedbackType[FeedbackType["positive"] = 1] = "positive";
            FeedbackType[FeedbackType["negative"] = 2] = "negative";
        })(FeedbackType = telemetry.FeedbackType || (telemetry.FeedbackType = {}));
        /**
         * @internal
         */
        var InputType;
        (function (InputType) {
            InputType[InputType["notSpecified"] = 0] = "notSpecified";
            InputType[InputType["mouse"] = 1] = "mouse";
            InputType[InputType["keyboard"] = 2] = "keyboard";
        })(InputType = telemetry.InputType || (telemetry.InputType = {}));
        /**
         * @internal
         */
        var ErrorLocation;
        (function (ErrorLocation) {
            ErrorLocation[ErrorLocation["client"] = 0] = "client";
            ErrorLocation[ErrorLocation["server"] = 1] = "server";
        })(ErrorLocation = telemetry.ErrorLocation || (telemetry.ErrorLocation = {}));
        /**
         * @internal
         */
        var SessionEvents;
        (function (SessionEvents) {
            SessionEvents[SessionEvents["begin"] = 0] = "begin";
            SessionEvents[SessionEvents["stateChange"] = 1] = "stateChange";
        })(SessionEvents = telemetry.SessionEvents || (telemetry.SessionEvents = {}));
        /**
         * Add control and form information to the eventArgs object
         * @internal
         */
        function createControlEvent(control, eventArgs) {
            var formName = "";
            var formUniqueId = "";
            if (control.Root) {
                formName = $dyn.value(control.Root.FormName);
                if (control.Root.Id) {
                    formUniqueId = control.Root.Id;
                }
            }
            if (!formName) {
                var activeForm_1 = $dyn.context($dyn.shell.getActiveForm());
                if (activeForm_1) {
                    formName = $dyn.value(activeForm_1.FormName);
                    formUniqueId = activeForm_1.Id;
                }
            }
            eventArgs.FormName = formName;
            eventArgs.FormUniqueId = formUniqueId;
            eventArgs.TargetName = control.Name ? control.Name : "";
            eventArgs.TargetType = control.TypeName ? control.TypeName : "";
            return eventArgs;
        }
        telemetry.createControlEvent = createControlEvent;
        /**
         * Add a performance event to the queue if telemetry is enabled
         * @internal
         * @returns The event if created, otherwise null
         */
        function addPerformanceEvent(formName, formUniqueId, performanceEvent, options) {
            if (performanceEvent == undefined) {
                return null;
            }
            var eventArgs = null;
            if ($dyn.telemetry.enabled) {
                if (!options) {
                    options = {};
                }
                eventArgs = $dyn.telemetry.createPerformanceEvent();
                eventArgs.PerformanceEvent = performanceEvent;
                eventArgs.FormName = formName;
                if (options.forceLog || $dyn.telemetry._shouldLogEvent(eventArgs)) {
                    eventArgs.FormUniqueId = formUniqueId;
                    eventArgs.TargetName = options.targetName ? options.targetName : "";
                    eventArgs.TargetType = options.targetType ? options.targetType : "";
                    eventArgs.Duration = options.duration ? options.duration : 0;
                    $dyn.log(
                    // tslint:disable-next-line:max-line-length
                    "PerformanceEvent-Logged: eventArgs.PerformanceEvent:%s, eventArgs.FormName:%s, eventArgs.FormUniqueId: %s  eventArgs.TargetName: %s eventArgs.TargeType:%s eventArgs.Duration: %s", eventArgs.PerformanceEvent, eventArgs.FormName, eventArgs.FormUniqueId, eventArgs.TargetName, eventArgs.TargetType, eventArgs.Duration);
                    $dyn.telemetry.addEvent(eventArgs);
                }
                else {
                    $dyn.log(
                    // tslint:disable-next-line:max-line-length
                    "PerformanceEvent-Skipped: eventArgs.PerformanceEvent:%s, eventArgs.FormName:%s, eventArgs.FormUniqueId: %s  eventArgs.TargetName: %s eventArgs.TargeType:%s eventArgs.Duration: %s", eventArgs.PerformanceEvent, eventArgs.FormName, eventArgs.FormUniqueId, eventArgs.TargetName, eventArgs.TargetType, eventArgs.Duration);
                }
            }
            return eventArgs;
        }
        telemetry.addPerformanceEvent = addPerformanceEvent;
        // Force the telementry event to be written if heuristics indicate.
        // Client-side interactions to the server when a single interaction (client+server+client) has > 0.5 seconds of combined client time
        // for non-form-open (adjust threshold up as needed to ensure reasonable volume on IE/Edge to improve client)
        // Open issues
        // - Interaction throttling will cause numbers to be higher than actual since waiting to group interactions as an optimization
        // - Matched interactions make a higher total
        // - Consider different thresholds between blocking interactions (e.g. ChangeSelectedIndex) vs. non-blocking/background interaction (e.g. SetValue)
        // - Need to determine right thresholds to get managable data to improve
        /**
         * Sum the times, and decide if it is over the threshold
         * @internal
         * @returns True if over threshold, otherwise false
         */
        function isCriticalPerformanceEvent(preClientTime, serverTime, postClientTime, action) {
            var shouldLog = false;
            var duration = preClientTime + serverTime + postClientTime;
            // TODO: Put in switch on action
            var durationThreshold = 1000; // 1.0 s
            if (duration > durationThreshold && action !== $dyn.label("PerformanceTimer_ClientAction") && action !== "ProcessEventData") {
                shouldLog = true;
            }
            return shouldLog;
        }
        telemetry.isCriticalPerformanceEvent = isCriticalPerformanceEvent;
        /**
         * Log a performance event if the times are over a threshold
         * @internal
         */
        function PerformanceTimer(preClientTime, serverTime, postClientTime, action, activityKey, blockingDivTime, blockingDivDescription) {
            var isCriticalPerforanceEvent = $dyn.telemetry.isCriticalPerformanceEvent(preClientTime, serverTime, postClientTime, action);
            var eventArgs = $dyn.telemetry.addPerformanceEvent("", "", $dyn.telemetry.PerformanceEvents.preClient, {
                targetName: action,
                // tslint:disable-next-line:object-literal-sort-keys
                duration: preClientTime,
                forceLog: isCriticalPerforanceEvent,
            });
            $dyn.telemetry.addPerformanceEvent("", "", $dyn.telemetry.PerformanceEvents.server, { targetName: action, duration: serverTime, forceLog: isCriticalPerforanceEvent });
            $dyn.telemetry.addPerformanceEvent("", "", $dyn.telemetry.PerformanceEvents.postClient, { targetName: action, duration: postClientTime, forceLog: isCriticalPerforanceEvent });
            $dyn.telemetry.addPerformanceEvent("", "", $dyn.telemetry.PerformanceEvents.blockingDiv, {
                targetName: blockingDivDescription,
                // tslint:disable-next-line:object-literal-sort-keys
                duration: blockingDivTime,
                forceLog: isCriticalPerforanceEvent,
            });
            if (isCriticalPerforanceEvent || (eventArgs && $dyn.telemetry._shouldLogEvent(eventArgs))) {
                if (activityKey) {
                    $dyn.browserActivity.newInteraction(activityKey);
                    $dyn.browserActivity.usePreviousActivityKey = true;
                }
                $dyn.telemetry.flushTelemetryEvents && $dyn.telemetry.flushTelemetryEvents();
            }
        }
        telemetry.PerformanceTimer = PerformanceTimer;
        /**
         * Add a session event to the queue if telemetry is enabled
         * @internal
         * @returns The event if created, otherwise null
         */
        function addSessionBeginEvent() {
            var eventArgs = null;
            if ($dyn.telemetry.enabled) {
                eventArgs = $dyn.telemetry.createSessionEvent();
                eventArgs.SessionAction = $dyn.telemetry.SessionEvents.begin;
                if ($dyn.telemetry._shouldLogEvent(eventArgs) && $.jqx) {
                    var response = new $.jqx.response();
                    var os = response.os;
                    var browser = response.browser;
                    var device = response.device;
                    var viewport = response.viewPort;
                    var cpuClass = "";
                    var osLanguage = "";
                    var browserLanguage = "";
                    if (navigator.cpuClass) {
                        cpuClass = navigator.cpuClass;
                    }
                    if (navigator.systemLanguage) {
                        osLanguage = navigator.systemLanguage;
                    }
                    if (navigator.userLanguage) {
                        browserLanguage = navigator.userLanguage;
                    }
                    else if (navigator.language) {
                        browserLanguage = navigator.language;
                    }
                    var user_1 = $dyn.user();
                    // TODO: Remove hardcoded edge cases
                    // Deliverable 3826671: Uptake to new version of OSS used for user agent parsing
                    var userAgent = navigator.userAgent;
                    var browserName = browser.name;
                    var browserVers = browser.version;
                    var foundIndex = userAgent.indexOf("Edge");
                    if (foundIndex !== -1) {
                        browserName = "Edge";
                        var endIndex = userAgent.indexOf(" ", foundIndex);
                        if (endIndex !== -1) {
                            browserVers = userAgent.substring(foundIndex + 5, endIndex);
                        }
                        else {
                            browserVers = userAgent.substring(foundIndex + 5);
                        }
                    }
                    var operatingSystem = void 0;
                    foundIndex = userAgent.indexOf("Windows NT 10.0");
                    if (foundIndex !== -1) {
                        operatingSystem = "Windows 10";
                    }
                    else {
                        operatingSystem = os.name + " " + os.version;
                    }
                    if (browserName === "Other") {
                        if (userAgent.indexOf("Windows") !== -1 && userAgent.indexOf("rv:11.0") !== -1) {
                            browserName = "Internet Explorer";
                        }
                    }
                    eventArgs.UserAgent = userAgent;
                    eventArgs.OperatingSystem = operatingSystem;
                    eventArgs.Platform = os.platform;
                    eventArgs.Device = device.type;
                    eventArgs.CpuClass = cpuClass;
                    eventArgs.BrowserName = browserName;
                    eventArgs.BrowserVersion = browserVers;
                    eventArgs.TouchEnabled = device.touch;
                    eventArgs.ScreenResolution = device.width + "x" + device.height;
                    eventArgs.ViewPortSize = viewport.width + "x" + viewport.height;
                    eventArgs.BrowserLanguage = browserLanguage;
                    eventArgs.OSLanguage = osLanguage;
                    eventArgs.ApplicationLanguage = $dyn.value(user_1.Language);
                    eventArgs.Locale = $dyn.value(user_1.Locale);
                    eventArgs.Density = $dyn.value(user_1.Density).toString();
                    eventArgs.Theme = $dyn.value(user_1.Theme).toString();
                    eventArgs.ClientVersion = $dyn.version.fullVerString;
                    $dyn.telemetry.addEvent(eventArgs);
                }
            }
            return eventArgs;
        }
        telemetry.addSessionBeginEvent = addSessionBeginEvent;
        /**
         * Add a ping event to the queue if telemetry is enabled
         * @internal
         * @param totalTime
         * @returns The event if created, otherwise null
         */
        function addPingEvent(totalTime) {
            var eventArgs = null;
            if ($dyn.telemetry.enabled) {
                eventArgs = $dyn.telemetry.createPingEvent();
                if ($dyn.telemetry._shouldLogEvent(eventArgs)) {
                    eventArgs.RoundTripTime = totalTime;
                    $dyn.telemetry.addEvent(eventArgs);
                }
            }
            return eventArgs;
        }
        telemetry.addPingEvent = addPingEvent;
        /**
         * Add an error event to the queue if telemetry is enabled
         * @internal
         * @param message The message to log
         */
        function addErrorEvent(message) {
            if (!message) {
                return null;
            }
            var eventArgs = null;
            if ($dyn.telemetry.enabled) {
                if (Array.isArray(message)) {
                    // Messages are only grouped if they are for the same form
                    var prevEventArgs = void 0;
                    // tslint:disable-next-line:prefer-for-of
                    for (var i = 0; i < message.length; i++) {
                        if (prevEventArgs && !message[i].formUniqueId) {
                            message[i].formUniqueId = prevEventArgs.FormUniqueId;
                            message[i].formName = prevEventArgs.FormName;
                        }
                        prevEventArgs = $dyn.telemetry.addErrorEvent(message[i]);
                    }
                }
                else {
                    eventArgs = $dyn.telemetry.createErrorEvent();
                    eventArgs.FormName = message.formName;
                    eventArgs.FormUniqueId = message.formUniqueId;
                    eventArgs.TargetName = message.targetName;
                    if ($dyn.telemetry._shouldLogEvent(eventArgs)) {
                        eventArgs.ErrorId = 0; // Still needs to be implemented
                        eventArgs.ErrorType = message.type;
                        eventArgs.ErrorLocation = $dyn.telemetry.ErrorLocation.client;
                        eventArgs.ErrorLabel = message.errorLabel;
                        eventArgs.CallStack = message.callStack;
                        eventArgs.StatusCode = message.statusCode;
                        $dyn.telemetry.addEvent(eventArgs);
                    }
                }
            }
            return eventArgs;
        }
        telemetry.addErrorEvent = addErrorEvent;
        /**
         * Whether or not to flush the telemetry events after a client error
         * Test code may trigger errors in the client/channels on purpose, this flag can be set to avoid the attempt to send a client error telemetry event to the server
         * @internal
         */
        telemetry.flushEventsAfterClientError = true;
        /**
         * Queue and flush a client error telemetry event with the given error text and label
         * @internal
         * @param label
         * @param additionalInfo Object containing the statusCode and callStack if applicable
         * @param isClientInError
         */
        function addClientErrorEvent(label, additionalInfo, isClientInError) {
            if ($dyn.telemetry.enabled) {
                var rootForm = $dyn.context($dyn.shell.getCurrentRootForm());
                var msg = new $dyn.messaging.Message();
                msg.errorLabel = label;
                msg.callStack = additionalInfo && additionalInfo.callStack ? additionalInfo.callStack : "";
                msg.statusCode = additionalInfo && additionalInfo.statusCode ? additionalInfo.statusCode : 0;
                msg.formName = rootForm ? rootForm.FormName : "";
                msg.formUniqueId = rootForm ? rootForm.Id : "";
                msg.type = $dyn.messaging.MessageType.error;
                msg.targetName = "";
                if (msg.callStack) {
                    var re = new RegExp(window.location.origin, "gi");
                    msg.callStack = msg.callStack.replace(re, "");
                }
                $dyn.telemetry.addErrorEvent(msg);
                if ($dyn.telemetry.flushEventsAfterClientError) {
                    // Don't try to flush the events to server if the client is already in an error state,
                    // this could lead to an infinite loop of attempts
                    if (isClientInError) {
                        $dyn.logError($dyn.label(label));
                    }
                    else {
                        $dyn.telemetry.flushTelemetryEvents && $dyn.telemetry.flushTelemetryEvents();
                    }
                }
            }
        }
        telemetry.addClientErrorEvent = addClientErrorEvent;
        /**
         * Display an error message box with the given options and logs a client error event
         * @internal
         * @param options Object to pass to $dyn.errorMessageBox
         * @param label
         * @param additionalInfo Object containing the statusCode and callStack if applicable
         */
        function handleClientError(options, label, additionalInfo) {
            if (!options.Label || options.Label.length == 0) {
                options.Label = label;
            }
            if (!options.Text || options.Text.length == 0) {
                options.Text = $dyn.label(label);
            }
            // The error message box call can change the value of the $dyn.clientInError flag
            // Need the original value to know if we are entering an error state or already in it
            var isClientInError = $dyn.value($dyn.clientInError);
            $dyn.errorMessageBox(options, true);
            $dyn.telemetry.addClientErrorEvent(label, additionalInfo, isClientInError);
        }
        telemetry.handleClientError = handleClientError;
        /**
         * Add an error event with the context of a control
         * @internal
         * @returns The event object
         */
        function addControlErrorEvent(control, label, callstack) {
            if (!control) {
                return null;
            }
            var options = {};
            options.errorLabel = label;
            options.callStack = callstack;
            options.targetName = control.Name;
            if (control.Root) {
                options.formName = $dyn.value(control.Root.FormName);
                if (control.Root.Id) {
                    options.formUniqueId = control.Root.Id;
                }
            }
            if (!options.formName) {
                var activeForm_2 = $dyn.context($dyn.shell.getActiveForm());
                if (activeForm_2) {
                    options.formName = $dyn.value(activeForm_2.FormName);
                    options.formUniqueId = activeForm_2.Id;
                }
            }
            return $dyn.telemetry.addErrorEvent(options);
        }
        telemetry.addControlErrorEvent = addControlErrorEvent;
        /**
         * Add an action event with the context of a control
         * @internal
         * @param control
         * @param eventArgs The cached event args, if applicable
         * @param action
         * @param options Object containing extra telemetry information like inputType
         * @returns The event object
         */
        function addControlActionEvent(control, eventArgs, action, options, forceLog) {
            if (!control || action == undefined) {
                return null;
            }
            if (control.TelemetryOptions) {
                // reset the telemetry options, want default if not explicitly passed into the options parameter
                control.TelemetryOptions = undefined;
                delete control.TelemetryOptions;
            }
            if (!options) {
                options = {};
            }
            if (!eventArgs) {
                eventArgs = $dyn.telemetry.createControlEvent(control, $dyn.telemetry.createActionEvent());
                eventArgs.ActionEvent = action;
            }
            if (forceLog || $dyn.telemetry._shouldLogEvent(eventArgs)) {
                // Use the default values if not defined
                // This info should not be cached, could be different for each time that event is fired
                eventArgs.InputType = options.inputType ? options.inputType : $dyn.telemetry.InputType.notSpecified;
                eventArgs.UserDefined1 = options.userDefined1 ? options.userDefined1 : 0;
                eventArgs.UserDefined2 = options.userDefined2 ? options.userDefined2 : 0;
                eventArgs.ExtendedData = options.extendedData ? options.extendedData : "";
                $dyn.telemetry.addEvent(eventArgs);
            }
            return eventArgs;
        }
        telemetry.addControlActionEvent = addControlActionEvent;
        /**
         * Add an action event with the context of a form
         * @internal
         * @param form
         * @param action
         * @param options Object containing extra telemetry information like inputType
         * @returns The event object
         */
        function addFormActionEvent(form, action, options) {
            if (!form || action == undefined) {
                return null;
            }
            var eventArgs = null;
            if ($dyn.telemetry.enabled) {
                eventArgs = $dyn.telemetry.createActionEvent();
                eventArgs.ActionEvent = action;
                eventArgs.FormName = form.FormName ? form.FormName : "";
                eventArgs.FormUniqueId = form.Id ? form.Id : "";
                if ($dyn.telemetry._shouldLogEvent(eventArgs)) {
                    if (!options) {
                        options = {};
                    }
                    eventArgs.TargetName = ""; // Needed for the data contract
                    eventArgs.TargetType = "Form";
                    eventArgs.InputType = options.inputType ? options.inputType : $dyn.telemetry.InputType.notSpecified;
                    eventArgs.UserDefined1 = options.userDefined1 ? options.userDefined1 : 0;
                    eventArgs.UserDefined2 = options.userDefined2 ? options.userDefined2 : 0;
                    eventArgs.ExtendedData = options.extendedData ? options.extendedData : "";
                    $dyn.telemetry.addEvent(eventArgs);
                }
            }
            return eventArgs;
        }
        telemetry.addFormActionEvent = addFormActionEvent;
        /**
         * Add an user feedback event
         * @internal
         * @returns The event object
         */
        function addUserFeedbackEvent(formName, formUniqueId, feedbackType, feedbackText) {
            var eventArgs = null;
            if ($dyn.telemetry.enabled) {
                eventArgs = $dyn.telemetry.createFeedbackEvent();
                eventArgs.FormName = formName;
                if ($dyn.telemetry._shouldLogEvent(eventArgs)) {
                    eventArgs.FormUniqueId = formUniqueId;
                    eventArgs.FeedbackType = feedbackType ? feedbackType : $dyn.telemetry.FeedbackType.notSpecified;
                    eventArgs.FeedbackText = feedbackText ? feedbackText : "";
                    eventArgs.FeedbackText += $dyn.browserActivity.FeedbackText;
                    $dyn.telemetry.addEvent(eventArgs);
                }
            }
            return eventArgs;
        }
        telemetry.addUserFeedbackEvent = addUserFeedbackEvent;
        /**
         * Add a navigation search event
         * @internal
         * @param time Round trip time it took to execute the query
         * @param query What the text the user searched
         * @param targetIndex The position in the drop down the user selected
         * @param targetMenuItemDescription The selected menu item's description
         * @returns The event object
         */
        function addNavigationSearchEvent(time, query, targetIndex, targetMenuItemDescription) {
            var eventArgs = null;
            if ($dyn.telemetry.enabled) {
                eventArgs = $dyn.telemetry.createNavigationSearchEvent();
                if ($dyn.telemetry._shouldLogEvent(eventArgs)) {
                    eventArgs.RoundTripTime = time;
                    eventArgs.Query = query;
                    eventArgs.TargetIndex = targetIndex;
                    eventArgs.TargetMenuItemDescription = targetMenuItemDescription;
                    $dyn.telemetry.addEvent(eventArgs);
                }
            }
            return eventArgs;
        }
        telemetry.addNavigationSearchEvent = addNavigationSearchEvent;
        /**
         * Add a navigation event
         * @internal
         * @param feature How the user navigated
         * @param navigationItem The name of the form/menuItem
         * @param path The path on where the user is going
         * @returns The event object
         */
        function addNavigationEvent(feature, navigationItem, path) {
            var eventArgs = null;
            if ($dyn.telemetry.enabled) {
                eventArgs = $dyn.telemetry.createNavigationEvent();
                if ($dyn.telemetry._shouldLogEvent(eventArgs)) {
                    // convert path to a string
                    var pathStr = "";
                    if (path && Array.isArray(path)) {
                        // tslint:disable-next-line:prefer-for-of
                        for (var i = 0; i < path.length; i++) {
                            if (pathStr.length > 0) {
                                pathStr += "\\";
                            }
                            pathStr += path[i].toString();
                        }
                    }
                    eventArgs.Feature = feature;
                    eventArgs.Path = pathStr;
                    eventArgs.NavigationItem = navigationItem;
                    $dyn.telemetry.addEvent(eventArgs);
                }
            }
            return eventArgs;
        }
        telemetry.addNavigationEvent = addNavigationEvent;
        /**
         * Add a communication event
         * @internal
         * @param responseTextStatus
         * @param responseHTTPStatus
         * @param requestTimeoutMilliseconds The timeout between attempts
         * @param requestRetryCount Which retry attempt it is on
         * @param browserSessionActivityId GUID for the current session, in case this telemetry is sent on a future session
         * @param readyState XMLHttpRequest readyState value
         * @param originalEventTimestamp include the current timestampe, in case this telemetry is sent on a future session
         * @returns The event object
         */
        function addCommunicationEvent(responseTextStatus, responseHTTPStatus, requestTimeoutMilliseconds, requestRetryCount, browserSessionActivityId, readyState) {
            var eventArgs = null;
            if ($dyn.telemetry.enabled) {
                eventArgs = $dyn.telemetry.createCommunicationEvent();
                if ($dyn.telemetry._shouldLogEvent(eventArgs)) {
                    // convert path to a string
                    eventArgs.ResponseTextStatus = responseTextStatus;
                    eventArgs.ResponseHTTPStatus = responseHTTPStatus;
                    eventArgs.RequestTimeoutMilliseconds = requestTimeoutMilliseconds;
                    eventArgs.RequestRetryCount = requestRetryCount;
                    eventArgs.BrowserSessionActivityId = browserSessionActivityId;
                    eventArgs.ReadyState = readyState;
                    eventArgs.OriginalEventTimestamp = Date.now();
                    $dyn.telemetry.addPersistentEvent(eventArgs);
                }
            }
            return eventArgs;
        }
        telemetry.addCommunicationEvent = addCommunicationEvent;
        /**
         * Add an action search event
         * @internal
         * @param form
         * @param query What the text the user searched
         * @param targetIndex The position in the drop down the user selected
         * @param targetName The name of the action the user selected
         * @param targetPath The path of the action the user selected
         * @returns The event object
         */
        function addActionSearchEvent(form, query, targetIndex, targetName, targetPath) {
            if (!form || !query) {
                return null;
            }
            var eventArgs = null;
            if ($dyn.telemetry.enabled) {
                eventArgs = $dyn.telemetry.createActionSearchEvent();
                eventArgs.FormName = form.FormName ? form.FormName : "";
                eventArgs.FormUniqueId = form.Id ? form.Id : "";
                if ($dyn.telemetry._shouldLogEvent(eventArgs)) {
                    eventArgs.Query = query;
                    eventArgs.TargetName = targetName ? targetName : "";
                    eventArgs.TargetPath = targetPath ? targetPath : "";
                    eventArgs.TargetIndex = targetIndex;
                    $dyn.telemetry.addEvent(eventArgs);
                }
            }
            return eventArgs;
        }
        telemetry.addActionSearchEvent = addActionSearchEvent;
        /**
         * The object describing what events should be logged by default
         * @internal
         * @readonly
         */
        telemetry.defaultConfiguration = {
            excludedEvents: {
                action: true,
                performance: true,
                // tslint:disable-next-line:object-literal-sort-keys
                navigation: true,
            },
        };
        /**
         * The object describing to allow all events
         * @internal
         * @readonly
         */
        telemetry.verboseConfiguration = {};
        if (!telemetry.configuration) {
            // configuration = $dyn.debug.verboseTelemetry ? verboseConfiguration : defaultConfiguration;
            /**
             * The object describing which events are allowed to be logged
             * @internal
             */
            telemetry.configuration = telemetry.defaultConfiguration;
        }
        /**
         * Determines if a type of event should be excluded
         * @internal
         * @param typeName The type of control
         * @param eventName The name of the event
         * @param eventType The event type
         */
        function isEventExcluded(typeName, eventName, eventType) {
            if (telemetry.configuration && telemetry.configuration.excludedEvents) {
                var globalSetting = telemetry.configuration.excludedEvents.global;
                if (typeof globalSetting === "boolean") {
                    return globalSetting;
                }
                else if (globalSetting) {
                    globalSetting = globalSetting[eventName];
                }
                var eventTypeSetting = telemetry.configuration.excludedEvents[eventType];
                if (typeof eventTypeSetting === "boolean") {
                    return eventTypeSetting;
                }
                else if (eventTypeSetting) {
                    eventTypeSetting = eventTypeSetting[eventName];
                }
                var typeNameSetting = telemetry.configuration.excludedEvents[typeName];
                if (typeof typeNameSetting === "boolean") {
                    return typeNameSetting;
                }
                else if (typeNameSetting) {
                    typeNameSetting = typeNameSetting[eventName];
                }
                return globalSetting || eventTypeSetting || typeNameSetting || false;
            }
            else {
                return false;
            }
        }
        telemetry.isEventExcluded = isEventExcluded;
        /**
         * Determines if we should log the passed in event
         * @internal
         */
        function _shouldLogEvent(event) {
            var shouldLog = true;
            if (telemetry.configuration && event) {
                if (event.FormName && telemetry.configuration.excludedForms && telemetry.configuration.excludedForms[event.FormName]) {
                    // Opt out of some forms
                    shouldLog = false;
                }
                else {
                    // Sometimes events are raised even though they are to be excluded, mostly in the case of direct raising
                    // Check if the event is to be exlcuded
                    var eventType = $dyn.util.enumName(event.$type, $dyn.telemetry.TelemetryEventDataType);
                    var eventName = void 0;
                    switch (eventType) {
                        case "performance":
                            eventName = $dyn.util.enumName(event.PerformanceEvent, $dyn.telemetry.PerformanceEvents);
                            break;
                        case "action":
                            eventName = $dyn.util.enumName(event.ActionEvent, $dyn.telemetry.ActionEvents);
                            break;
                        case "sessionAction":
                            eventName = $dyn.util.enumName(event.SessionAction, $dyn.telemetry.SessionEvents);
                            break;
                    }
                    shouldLog = !$dyn.telemetry.isEventExcluded(event.TargetType, eventName, eventType);
                }
                if (shouldLog && telemetry.configuration.includedForms) {
                    shouldLog = false;
                    var formConfiguration = telemetry.configuration.includedForms[event.FormName];
                    if (formConfiguration) {
                        if (typeof formConfiguration == "boolean") {
                            shouldLog = formConfiguration;
                        }
                        else if (formConfiguration.includedControls && event.TargetName) {
                            var controlConfiguration = formConfiguration.includedControls[event.TargetName];
                            if (controlConfiguration) {
                                if (typeof controlConfiguration == "boolean") {
                                    shouldLog = controlConfiguration;
                                }
                                else if (event.ActionEvent) {
                                    shouldLog = controlConfiguration.includedEvents[$dyn.util.enumName(event.ActionEvent, $dyn.telemetry.ActionEvents)];
                                }
                                else if (event.PerformanceEvent) {
                                    shouldLog = controlConfiguration.includedEvents[$dyn.util.enumName(event.PerformanceEvent, $dyn.telemetry.PerformanceEvents)];
                                }
                            }
                        }
                    }
                }
            }
            return shouldLog;
        }
        telemetry._shouldLogEvent = _shouldLogEvent;
        /**
         * Determines if a type of control has excluded events in the configuration
         * @internal
         * @param typeName The type of control
         */
        function hasExcludedEvent(typeName) {
            return telemetry.configuration && telemetry.configuration.excludedEvents && telemetry.configuration.excludedEvents[typeName];
        }
        telemetry.hasExcludedEvent = hasExcludedEvent;
        /**
         * A set of type specific handlers
         * @internal
         */
        telemetry.typeHandlers = {};
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.Button = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var clicked = control.Clicked;
                var keydown = control.keyDown;
                var clickTelemetryEventArgs;
                var clickEventCategory = $dyn.telemetry.ActionEvents.buttonClicked;
                var clickOptions = { inputType: $dyn.telemetry.InputType.mouse };
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(clickEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.keyDown = function (evt) {
                        if (evt.which == $dyn.ui.KeyCodes.enter) {
                            control.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        }
                        $dyn.applyFunction(keydown, control, arguments);
                    };
                    control.Clicked = function (evt) {
                        if (control.TelemetryOptions) {
                            clickOptions.inputType = control.TelemetryOptions.inputType;
                        }
                        else if (evt && evt.type == "click") {
                            clickOptions.inputType = $dyn.telemetry.InputType.mouse;
                        }
                        else {
                            clickOptions.inputType = $dyn.telemetry.InputType.notSpecified;
                        }
                        clickTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, clickTelemetryEventArgs, clickEventCategory, clickOptions);
                        // Apply the base method
                        clicked.apply(this, arguments);
                    };
                }
            },
        };
        $dyn.telemetry.typeHandlers.CommandButton = $dyn.telemetry.typeHandlers.Button;
        $dyn.telemetry.typeHandlers.AnchorButton = $dyn.telemetry.typeHandlers.Button;
        $dyn.telemetry.typeHandlers.Tile = $dyn.telemetry.typeHandlers.Button;
        $dyn.telemetry.typeHandlers.ToggleButton = $dyn.telemetry.typeHandlers.Button;
        $dyn.telemetry.typeHandlers.MenuItemButton = $dyn.telemetry.typeHandlers.Button;
        $dyn.telemetry.typeHandlers.SymbolButton = $dyn.telemetry.typeHandlers.Button;
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.MenuButton = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var menuButtonClickedTelemetryEventArgs;
                var menuButtonClickedEventCategory = $dyn.telemetry.ActionEvents.buttonClicked;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(menuButtonClickedEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.usingDisposable($dyn.observe(control.ShowFlyout, function recordTelemetry(value) {
                        if (value) {
                            menuButtonClickedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, menuButtonClickedTelemetryEventArgs, menuButtonClickedEventCategory, control.TelemetryOptions);
                        }
                    }));
                }
            },
        };
        $dyn.telemetry.typeHandlers.DropDialogButton = $dyn.telemetry.typeHandlers.MenuButton;
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.HyperLink = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var clicked = control.clicked;
                var keydown = control.keyDown;
                var clickTelemetryEventArgs;
                var clickEventCategory = $dyn.telemetry.ActionEvents.buttonClicked;
                var clickOptions = { inputType: $dyn.telemetry.InputType.mouse };
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(clickEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.keyDown = function (evt) {
                        if (evt.which == $dyn.ui.KeyCodes.enter) {
                            control.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        }
                        $dyn.applyFunction(keydown, control, arguments);
                    };
                    control.clicked = function (evt) {
                        if (control.TelemetryOptions) {
                            clickOptions.inputType = control.TelemetryOptions.inputType;
                        }
                        else if (evt && evt.type == "click") {
                            clickOptions.inputType = $dyn.telemetry.InputType.mouse;
                        }
                        else {
                            clickOptions.inputType = $dyn.telemetry.InputType.notSpecified;
                        }
                        clickTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, clickTelemetryEventArgs, clickEventCategory, clickOptions);
                        // Apply the base method
                        clicked.apply(this, arguments);
                    };
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.Input = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var valueChangedTelemetryEventArgs;
                if (control.valueBinder) {
                    var oldSetter_1 = control.valueBinder.setValue;
                    var valueChangedEventCategory_1 = $dyn.telemetry.ActionEvents.valueChanged;
                    if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(valueChangedEventCategory_1, $dyn.telemetry.ActionEvents))) {
                        control.valueBinder.setValue = function () {
                            valueChangedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, valueChangedTelemetryEventArgs, valueChangedEventCategory_1);
                            $dyn.applyFunction(oldSetter_1, control.valueBinder, arguments);
                        };
                    }
                }
                var executeHyperlink = control.ExecuteHyperlink;
                var linkTelemetryEventArgs;
                var linkEventCategory = $dyn.telemetry.ActionEvents.jumpRefExecuted;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(linkEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.ExecuteHyperlink = function () {
                        linkTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, linkTelemetryEventArgs, linkEventCategory, control.TelemetryOptions);
                        // Apply the base method
                        $dyn.applyFunction(executeHyperlink, control, arguments);
                    };
                }
                var lookupActivatedTelemetryEventArgs;
                var lookupActivatedEventCategory = $dyn.telemetry.ActionEvents.lookupActivated;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(lookupActivatedEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.usingDisposable($dyn.observe(control.ShowFlyout, function recordTelemetry(value) {
                        if (value) {
                            // Only record the opening of the lookup if was manually triggered. We don't care about the auto-open case.
                            var inputType = control.TelemetryOptions ? control.TelemetryOptions.inputType : undefined;
                            if (inputType === $dyn.telemetry.InputType.keyboard || inputType === $dyn.telemetry.InputType.mouse) {
                                lookupActivatedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, lookupActivatedTelemetryEventArgs, lookupActivatedEventCategory, control.TelemetryOptions);
                            }
                        }
                    }));
                }
            },
        };
        $dyn.telemetry.typeHandlers.String = $dyn.telemetry.typeHandlers.Input;
        $dyn.telemetry.typeHandlers.MultilineInput = $dyn.telemetry.typeHandlers.Input;
        $dyn.telemetry.typeHandlers.Int64 = $dyn.telemetry.typeHandlers.Input;
        $dyn.telemetry.typeHandlers.Integer = $dyn.telemetry.typeHandlers.Input;
        $dyn.telemetry.typeHandlers.Real = $dyn.telemetry.typeHandlers.Input;
        $dyn.telemetry.typeHandlers.Date = $dyn.telemetry.typeHandlers.Input;
        $dyn.telemetry.typeHandlers.DateTime = $dyn.telemetry.typeHandlers.Input;
        $dyn.telemetry.typeHandlers.Time = $dyn.telemetry.typeHandlers.Input;
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.Image = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var clicked = control.clicked;
                var keydown = control.keyDown;
                var clickTelemetryEventArgs;
                var clickEventCategory = $dyn.telemetry.ActionEvents.buttonClicked;
                var clickOptions = { inputType: $dyn.telemetry.InputType.mouse };
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(clickEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.keyDown = function (evt) {
                        if (evt.which === $dyn.ui.KeyCodes.enter || evt.which === $dyn.ui.KeyCodes.spacebar) {
                            control.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        }
                        $dyn.applyFunction(keydown, control, arguments);
                    };
                    control.clicked = function (evt) {
                        if (control.TelemetryOptions) {
                            clickOptions.inputType = control.TelemetryOptions.inputType;
                        }
                        else if (evt && evt.type == "click") {
                            clickOptions.inputType = $dyn.telemetry.InputType.mouse;
                        }
                        else {
                            clickOptions.inputType = $dyn.telemetry.InputType.notSpecified;
                        }
                        clickTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, clickTelemetryEventArgs, clickEventCategory, clickOptions);
                        // Apply the base method
                        clicked.apply(this, arguments);
                    };
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.EnumControl = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var itemSelectedTelemetryEventArgs;
                var itemSelectedEventOptions;
                var itemSelectedEventCategory = $dyn.telemetry.ActionEvents.itemSelected;
                var setSelectedItem = control.setSelectedIndex;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(itemSelectedEventCategory, $dyn.telemetry.ActionEvents))) {
                    var oldValue_1 = $dyn.value(control.selectedIndex);
                    control.setSelectedIndex = function (index) {
                        var itemsLength = $dyn.length(control.Items);
                        if (itemsLength > index && index >= 0 && index != oldValue_1) {
                            oldValue_1 = index;
                            itemSelectedEventOptions = { userDefined1: index + 1, userDefined2: $dyn.length(control.Items) };
                            if (control.TelemetryOptions) {
                                itemSelectedEventOptions.inputType = control.TelemetryOptions.inputType;
                            }
                            itemSelectedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, itemSelectedTelemetryEventArgs, itemSelectedEventCategory, itemSelectedEventOptions);
                        }
                        return $dyn.applyFunction(setSelectedItem, control, arguments);
                    };
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.ComboBox = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                $dyn.telemetry.typeHandlers.EnumControl.instrument(control);
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var lookupActivatedTelemetryEventArgs;
                var lookupActivatedEventCategory = $dyn.telemetry.ActionEvents.lookupActivated;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(lookupActivatedEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.usingDisposable($dyn.observe(control.isExpanded, function (newValue) {
                        if (newValue) {
                            lookupActivatedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, lookupActivatedTelemetryEventArgs, lookupActivatedEventCategory, control.TelemetryOptions);
                        }
                    }));
                }
            },
        };
        $dyn.telemetry.typeHandlers.ListBox = $dyn.telemetry.typeHandlers.EnumControl;
        $dyn.telemetry.typeHandlers.RadioButton = $dyn.telemetry.typeHandlers.EnumControl;
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.CheckBox = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var valueChangedTelemetryEventArgs;
                var valueChangedTelemetryOptions;
                var toggleValue = control.toggleValue;
                var valueChangedEventCategory = $dyn.telemetry.ActionEvents.valueChanged;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(valueChangedEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.toggleValue = function (evt) {
                        if (evt && (evt.type == "click" || evt.type == "mousedown")) {
                            valueChangedTelemetryOptions = { inputType: $dyn.telemetry.InputType.mouse };
                        }
                        else if (evt && evt.type == "keydown") {
                            valueChangedTelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        }
                        else {
                            valueChangedTelemetryOptions = undefined;
                        }
                        valueChangedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, valueChangedTelemetryEventArgs, valueChangedEventCategory, valueChangedTelemetryOptions);
                        $dyn.applyFunction(toggleValue, control, arguments);
                    };
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.ReferenceGroup = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var lookupActivatedTelemetryEventArgs;
                var lookupActivatedEventCategory = $dyn.telemetry.ActionEvents.lookupActivated;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(lookupActivatedEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.usingDisposable($dyn.observe(control.ShowFlyout, function recordTelemetry(value) {
                        if (value) {
                            // Only record the opening of the lookup if was manually triggered. We don't care about the auto-open case.
                            var inputType = control.TelemetryOptions ? control.TelemetryOptions.inputType : undefined;
                            if (inputType === $dyn.telemetry.InputType.keyboard || inputType === $dyn.telemetry.InputType.mouse) {
                                lookupActivatedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, lookupActivatedTelemetryEventArgs, lookupActivatedEventCategory, control.TelemetryOptions);
                            }
                        }
                    }));
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.PanoramaItem = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var headerClicked = control.HeaderClicked;
                var keydown = control.keyDown;
                var headerClickedTelemetryEventArgs;
                var headerClickedEventOptions = { inputType: $dyn.telemetry.InputType.mouse };
                var headerClickedEventCategory = $dyn.telemetry.ActionEvents.buttonClicked;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(headerClickedEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.keyDown = function (evt) {
                        if (evt.which == $dyn.ui.KeyCodes.enter) {
                            control.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        }
                        $dyn.callFunction(keydown, control, evt);
                    };
                    control.HeaderClicked = function (event) {
                        if (control.TelemetryOptions) {
                            headerClickedEventOptions.inputType = control.TelemetryOptions.inputType;
                        }
                        else if (event && event.type == "click") {
                            headerClickedEventOptions.inputType = $dyn.telemetry.InputType.mouse;
                        }
                        else {
                            headerClickedEventOptions.inputType = $dyn.telemetry.InputType.notSpecified;
                        }
                        headerClickedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, headerClickedTelemetryEventArgs, headerClickedEventCategory, headerClickedEventOptions);
                        $dyn.applyFunction(headerClicked, control, arguments);
                    };
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.PivotItem = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var activateItem = control.Activate;
                var keydown = control.keyDown;
                var activateItemTelemetryEventArgs;
                var activateItemEventOptions = { inputType: $dyn.telemetry.InputType.mouse };
                var activateItemEventCategory = $dyn.telemetry.ActionEvents.itemSelected;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(activateItemEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.keyDown = function (evt) {
                        if (evt.which == $dyn.ui.KeyCodes.enter) {
                            control.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        }
                        $dyn.callFunction(keydown, control, evt);
                    };
                    control.Activate = function (event) {
                        if (control.TelemetryOptions) {
                            activateItemEventOptions.inputType = control.TelemetryOptions.inputType;
                        }
                        else if (event && event.type == "click") {
                            activateItemEventOptions.inputType = $dyn.telemetry.InputType.mouse;
                        }
                        else {
                            activateItemEventOptions.inputType = $dyn.telemetry.InputType.notSpecified;
                        }
                        activateItemTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, activateItemTelemetryEventArgs, activateItemEventCategory, activateItemEventOptions);
                        $dyn.applyFunction(activateItem, control, arguments);
                    };
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.SectionPage = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var keydown = control.keyDown;
                var expandedTelemetryEventArgs;
                var collapsedTelemetryEventArgs;
                var expandedChangedEventOptions = { inputType: $dyn.telemetry.InputType.mouse };
                if (!hasExcludedEvents ||
                    !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName($dyn.telemetry.ActionEvents.containerExpand, $dyn.telemetry.ActionEvents)) ||
                    !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName($dyn.telemetry.ActionEvents.containerCollapse, $dyn.telemetry.ActionEvents))) {
                    control.keyDown = function (evt) {
                        if (evt.which == $dyn.ui.KeyCodes.enter || evt.which == $dyn.ui.KeyCodes.spacebar) {
                            control.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        }
                        $dyn.callFunction(keydown, control, evt);
                    };
                    control.recordTelemetry = function (event) {
                        if (control.TelemetryOptions) {
                            expandedChangedEventOptions.inputType = control.TelemetryOptions.inputType;
                        }
                        else if (event && event.type == "click") {
                            expandedChangedEventOptions.inputType = $dyn.telemetry.InputType.mouse;
                        }
                        else {
                            expandedChangedEventOptions.inputType = $dyn.telemetry.InputType.notSpecified;
                        }
                        // Need two different addControlAction event calls because the event type gets cached.
                        if ($dyn.value(control.Expanded)) {
                            expandedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, expandedTelemetryEventArgs, $dyn.telemetry.ActionEvents.containerExpand, expandedChangedEventOptions);
                        }
                        else {
                            collapsedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, collapsedTelemetryEventArgs, $dyn.telemetry.ActionEvents.containerCollapse, expandedChangedEventOptions);
                        }
                    };
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.AppBarTab = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var tabShown = control.TabShown;
                var expandEventCategory = $dyn.telemetry.ActionEvents.containerExpand;
                var expandedTelemetryEventArgs;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(expandEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.TabShown = function () {
                        expandedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, expandedTelemetryEventArgs, expandEventCategory, control.TelemetryOptions);
                        $dyn.applyFunction(tabShown, control, arguments);
                    };
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.NavigationBar = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var messageCenterTelemetryEventArgs;
                var messageCenterEventOptions = { extendedData: "MessageCenter" };
                var userSettingsTelemetryEventArgs;
                var userSettingsEventOptions = { extendedData: "UserSettings" };
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName($dyn.telemetry.ActionEvents.containerExpand, $dyn.telemetry.ActionEvents))) {
                    control.recordMessageCenterTelemetry = function () {
                        if (control.TelemetryOptions) {
                            messageCenterEventOptions.inputType = control.TelemetryOptions.inputType;
                        }
                        messageCenterTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, messageCenterTelemetryEventArgs, $dyn.telemetry.ActionEvents.containerExpand, messageCenterEventOptions);
                    };
                    control.recordUserSettingsTelemetry = function () {
                        if (control.TelemetryOptions) {
                            userSettingsEventOptions.inputType = control.TelemetryOptions.inputType;
                        }
                        userSettingsTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, userSettingsTelemetryEventArgs, $dyn.telemetry.ActionEvents.containerExpand, userSettingsEventOptions);
                    };
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.User = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var userButtonTelemetryEventArgs;
                var userButtonEventCategory = $dyn.telemetry.ActionEvents.containerExpand;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(userButtonEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.recordTelemetry = function () {
                        userButtonTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, userButtonTelemetryEventArgs, userButtonEventCategory, control.TelemetryOptions);
                    };
                }
            },
        };
        /**
         * @internal
         */
        $dyn.telemetry.typeHandlers.Tree = {
            instrument: function (control) {
                if (!control) {
                    return;
                }
                var hasExcludedEvents = $dyn.telemetry.hasExcludedEvent(control.TypeName);
                var addItemEventCategory = $dyn.telemetry.ActionEvents.addItem;
                var addNodeTelemetryEventArgs;
                var addNodeEventOptions;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(addItemEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.RecordAddTelemetry = function (nodeId) {
                        addNodeEventOptions = { userDefined1: nodeId };
                        addNodeTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, addNodeTelemetryEventArgs, addItemEventCategory, addNodeEventOptions);
                    };
                }
                var removeItemEventCategory = $dyn.telemetry.ActionEvents.removeItem;
                var removeNodeTelemetryEventArgs;
                var removeNodeEventOptions;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(removeItemEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.RecordRemoveTelemetry = function (nodeId) {
                        removeNodeEventOptions = { userDefined1: nodeId };
                        removeNodeTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, removeNodeTelemetryEventArgs, removeItemEventCategory, removeNodeEventOptions);
                    };
                }
                var valueChangedEventCategory = $dyn.telemetry.ActionEvents.valueChanged;
                var nodeChangedTelemetryEventArgs;
                var nodeChangedEventOptions;
                if (!hasExcludedEvents || !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName(valueChangedEventCategory, $dyn.telemetry.ActionEvents))) {
                    control.RecordEditTelemetry = function (nodeId) {
                        nodeChangedEventOptions = { userDefined1: nodeId };
                        nodeChangedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, nodeChangedTelemetryEventArgs, valueChangedEventCategory, nodeChangedEventOptions);
                    };
                }
                var checkBoxClick = control.CheckBoxClick;
                var itemSelectedTelemetryEventArgs;
                var itemUnselectedTelemetryEventArgs;
                var itemSelectedEventOptions;
                if (!hasExcludedEvents ||
                    !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName($dyn.telemetry.ActionEvents.itemSelected, $dyn.telemetry.ActionEvents)) ||
                    !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName($dyn.telemetry.ActionEvents.itemUnselected, $dyn.telemetry.ActionEvents))) {
                    control.CheckBoxClick = function (node, evt) {
                        itemSelectedEventOptions = { extendedData: $dyn.value(control.Name), userDefined1: node.NodeId() };
                        if (control.TelemetryOptions) {
                            itemSelectedEventOptions.inputType = control.TelemetryOptions.inputType;
                        }
                        else if (evt && evt.type == "click") {
                            itemSelectedEventOptions.inputType = $dyn.telemetry.InputType.mouse;
                        }
                        else {
                            itemSelectedEventOptions.inputType = $dyn.telemetry.InputType.notSpecified;
                        }
                        var checkedValue = node.CheckedState();
                        if (checkedValue == $dyn.ui.CheckedState.Checked) {
                            itemUnselectedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, itemUnselectedTelemetryEventArgs, $dyn.telemetry.ActionEvents.itemUnselected, itemSelectedEventOptions);
                        }
                        else {
                            itemSelectedTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, itemSelectedTelemetryEventArgs, $dyn.telemetry.ActionEvents.itemSelected, itemSelectedEventOptions);
                        }
                        $dyn.applyFunction(checkBoxClick, control, arguments);
                    };
                }
                var expandCollapse = control.ExpandCollapse;
                var collapseTelemetryEventArgs;
                var expandTelemetryEventArgs;
                var expandCollapseEventOptions;
                if (!hasExcludedEvents ||
                    !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName($dyn.telemetry.ActionEvents.containerCollapse, $dyn.telemetry.ActionEvents)) ||
                    !$dyn.telemetry.isEventExcluded(control.TypeName, $dyn.util.enumName($dyn.telemetry.ActionEvents.containerExpand, $dyn.telemetry.ActionEvents))) {
                    control.ExpandCollapse = function (node, value) {
                        if (control.Root && !$dyn.value(control.Root.Updating)) {
                            expandCollapseEventOptions = { extendedData: $dyn.value(control.Name), userDefined1: node.NodeId() };
                            if (control.TelemetryOptions) {
                                expandCollapseEventOptions.inputType = control.TelemetryOptions.inputType;
                            }
                            if (value) {
                                expandTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, expandTelemetryEventArgs, $dyn.telemetry.ActionEvents.containerExpand, expandCollapseEventOptions);
                            }
                            else {
                                collapseTelemetryEventArgs = $dyn.telemetry.addControlActionEvent(control, collapseTelemetryEventArgs, $dyn.telemetry.ActionEvents.containerCollapse, expandCollapseEventOptions);
                            }
                        }
                        $dyn.applyFunction(expandCollapse, control, arguments);
                    };
                }
            },
        };
        if (telemetry.configuration && telemetry.configuration.excludedEvents) {
            // tslint:disable-next-line:forin
            for (var controlType in telemetry.configuration.excludedEvents) {
                var excludedEvent = telemetry.configuration.excludedEvents[controlType];
                if (excludedEvent === true) {
                    delete $dyn.telemetry.typeHandlers[controlType];
                }
            }
        }
        /**
         * The name of the last focused control
         * @internal
         */
        telemetry._lastFocused = "";
        /**
         * Determines if the new control that has focus is different than the last control that had focus
         * @internal
         * @param controlName The name of the newly focused control
         */
        function _shouldLogFocusEvent(controlName) {
            if (controlName && controlName.toLowerCase() !== $dyn.telemetry._lastFocused) {
                $dyn.telemetry._lastFocused = controlName.toLowerCase();
                return true;
            }
            return false;
        }
        telemetry._shouldLogFocusEvent = _shouldLogFocusEvent;
        /**
         * Setup event handlers to be able to log focus telemetry
         * @internal
         */
        function initializeFocusTelemetry() {
            $dyn.telemetry.keydownFocus = function (evt) {
                if (evt && evt.which === $dyn.ui.KeyCodes.tab) {
                    $dyn.telemetry.keyboardFocus = true;
                }
            };
            $dyn.telemetry.keyupFocus = function () {
                $dyn.telemetry.keyboardFocus = false;
            };
            document.addEventListener("keydown", $dyn.telemetry.keydownFocus, true);
            document.addEventListener("keyup", $dyn.telemetry.keyupFocus, true);
            $dyn.telemetry.mousedownFocus = function (evt) {
                $dyn.telemetry.mouseFocus = true;
            };
            $dyn.telemetry.mosueupFocus = function () {
                $dyn.telemetry.mouseFocus = false;
            };
            document.addEventListener("mousedown", $dyn.telemetry.mousedownFocus, true);
            document.addEventListener("mouseup", $dyn.telemetry.mosueupFocus, true);
            $dyn.telemetry.focusInHandler = function (evt) {
                var control = $dyn.context(evt.target);
                if (control && $dyn.telemetry._shouldLogFocusEvent(control.Name)) {
                    var options_1 = {};
                    if ($dyn.telemetry.keyboardFocus) {
                        options_1.inputType = $dyn.telemetry.InputType.keyboard;
                    }
                    else if ($dyn.telemetry.mouseFocus) {
                        options_1.inputType = $dyn.telemetry.InputType.mouse;
                    }
                    $dyn.telemetry.addControlActionEvent(control, undefined, $dyn.telemetry.ActionEvents.receivedFocus, options_1);
                }
            };
            document.addEventListener("focusin", $dyn.telemetry.focusInHandler);
        }
        telemetry.initializeFocusTelemetry = initializeFocusTelemetry;
        if ($dyn.telemetry.enabled && !$dyn.telemetry.isEventExcluded("", "receivedFocus", "action")) {
            $dyn.telemetry.initializeFocusTelemetry();
        }
        // queue unsent telemetry events from the previous session
        if ($dyn.util.localStorageSupported()) {
            var persistentEventString = window.localStorage.getItem($dyn.telemetry._storageKey);
            if (persistentEventString) {
                var persistentEventQueue = JSON.parse(persistentEventString);
                if (persistentEventQueue && persistentEventQueue.length > 0) {
                    $dyn.telemetry._areEventsStored = true;
                    persistentEventQueue.forEach(function (evt) {
                        $dyn.telemetry.addEvent(evt);
                    });
                }
            }
        }
    })(telemetry = $dyn.telemetry || ($dyn.telemetry = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=html-binding-telemetry.js.map
